import { render, staticRenderFns } from "./AppHeaderRegistration.vue?vue&type=template&id=68ed0734&scoped=true&"
import script from "./AppHeaderRegistration.vue?vue&type=script&lang=js&"
export * from "./AppHeaderRegistration.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderRegistration.vue?vue&type=style&index=0&id=68ed0734&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ed0734",
  null
  
)

export default component.exports